export const LogoMark = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <circle cx="32" cy="26" r="9" fill="url(#gvSun)" />
    <path d="M6 46 C18 34 26 34 32 42 C38 34 46 34 58 46" stroke="url(#gvGold)" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <path d="M12 52 C22 44 28 44 32 49 C36 44 42 44 52 52" stroke="url(#gvGold)" strokeWidth="1.6" fill="none" strokeLinecap="round" opacity="0.7" />
    <defs>
      <linearGradient id="gvSun" x1="23" y1="17" x2="41" y2="35" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F4E5C2" />
        <stop offset="1" stopColor="#C5A059" />
      </linearGradient>
      <linearGradient id="gvGold" x1="6" y1="34" x2="58" y2="52" gradientUnits="userSpaceOnUse">
        <stop stopColor="#8F7034" />
        <stop offset="0.5" stopColor="#EED8A1" />
        <stop offset="1" stopColor="#8F7034" />
      </linearGradient>
    </defs>
  </svg>
);

export const Logo = () => (
  <a href="#top" data-testid="navbar-brand-logo" className="flex items-center gap-3 group">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-serif text-lg tracking-[0.18em] gold-text">GOLDEN VALLEY</span>
      <span className="block text-[10px] tracking-[0.42em] text-[#8A8270] mt-1">SARAJEVO</span>
    </span>
  </a>
);
